import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGenericCarbonTypical = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 5V7H10V14H8V7H5V5H13Z",
		fill: "black"
	})
});
export default SvgGenericCarbonTypical;
